<template>
    <div>
        <st-data-table
            :items="items"
            :fields="fields"
            :actions="actions"
            :modelPresenter="presenter"
            @edit="onEdit"
            @delete="onDelete"
            responsive="sm"
            hover
        >
        </st-data-table>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import { ResponseTemplatesModel } from '@/modules/response-templates/response-templates-model';
    const { fields } = ResponseTemplatesModel;

    export default {
        name: 'ComplainTypeListTable',
        data() {
            return {
                presenter: ResponseTemplatesModel.presenter,
                actions: [
                    {
                        name: 'edit',
                        icon: 'edit',
                        tooltipText: this.$t('GENERAL.ACTIONS.EDIT'),
                        customIcon: false,
                        type: 'primary'
                    },
                    {
                        name: 'delete',
                        icon: 'trash',
                        tooltipText: this.$t('GENERAL.ACTIONS.DELETE'),
                        customIcon: false,
                        type: 'primary'
                    }
                ],
            };
        },
        computed: {
            ...mapGetters({
                rows: 'responseTemplates/list/rows',
            }),
            fields() {
                return [
                    fields.title,
                    fields.categoryTranslated,
                    { key: 'Actions', label: this.$t('RESPONSE_TEMPLATES.LIST.ACTIONS')},
                ]
            },
            items() {
                return this.formatRows();
            },
        },
        methods: {
            ...mapActions({
                selectRecord: 'responseTemplates/form/select',
                deleteRecord: 'responseTemplates/form/remove',
            }),
            async onEdit(data) {
                await this.selectRecord(data.item);
            },
            async onDelete(data) {
                await this.deleteRecord(data.item.id);
            },
            formatRows() {
                return this.rows.map((row) => {
                    row.categoryTranslated = this.$t(`RESPONSE_TEMPLATES.CATEGORY.${row.category.toUpperCase()}`);
                    return row;
                })
            },
        },
    };
</script>

<style scoped>

</style>
